import * as Sentry from '@sentry/react'
import microApp from '@micro-zoe/micro-app'
import ReactDOM from 'react-dom/client'
import AuthPage from './AuthPage'
import ContextWrapper from './contexts'
import './i18n'
import './preloadError'
import reportWebVitals from './reportWebVitals'
import './style/applies.css'
import './style/classes.css'
import './style/common.less'
import './style/index.css'
import './style/markdown.css'

// /* sentry预警 */
Sentry.init({
  dsn: 'https://99fd7c830196ef46ed2d60ba0ce85913@sentry.baiying.com.cn/76',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
;(window as any).__MAIN_APP_BASE_URL__ = window.location.origin
microApp.start()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <ContextWrapper>
    <AuthPage />
  </ContextWrapper>
)
reportWebVitals()

// 预加载 会话页面使用的资源
setTimeout(() => {
  import('./pages/ChatAppPage').then(module => {
    console.log('SkillChatPage preloaded')
  })
}, 3000)
